module.exports = __webpack_public_path__ + "files/Boma Program Outline.pdf";